export default "__VITE_ASSET__ZHuY92pW__"